module.exports = __webpack_public_path__ + "media/test/banner-6e7d5d56.png";